import { DrawerActionTypes } from "./drawer.types";

const INITIAL_STATE = {
  Hidden: true,
};

const drawerReducer = (currentState = INITIAL_STATE, action) => {
  switch (action.type) {
    case DrawerActionTypes.SHOW_DRAWER:
      return {
        ...currentState,
        Hidden: !currentState.Hidden,
      };
    default:
      return currentState;
  }
};

export default drawerReducer;
